import { useMatches } from '@remix-run/react'
import type { LandingPageData } from '@pages/LandingPage'
import type { LandingPageLoader } from 'app/routes/$locale.($slug)._index'

export const useLandingPageData = (): LandingPageData['landingPageData'] => {
  const matches = useMatches()
  const matchData = matches.find(
    ({ id }) => id === 'routes/$locale.($slug)._index'
  )

  // @TODO: find a better way to type useMatches data
  const landingPageData = (matchData?.data as LandingPageLoader | undefined)
    ?.landingPage?.landingPageData

  return (
    landingPageData ||
    ({ landingPageData: {} } as unknown as LandingPageData['landingPageData'])
  )
}
